var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgBodyBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 180,
    viewBox: "0 0 317 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2131_15722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.118 132.664H123.363L128.118 99.1615H111.476C108.718 99.1615 108.765 97.63 109.669 96.0027C110.572 94.3754 109.907 95.6198 110.002 95.4284C116.136 84.5161 125.36 68.2434 137.628 46.5146H142.383L137.628 80.0172H154.271C156.601 80.0172 156.933 81.5966 156.506 82.4581L156.173 83.176C137.438 116.152 128.118 132.664 128.118 132.664Z",
    fill: "#D3D3D3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5355 56.1842C79.1926 56.1842 80.5226 51.7774 82.6003 49.359C84.0869 47.6287 86.624 48.1446 87.3749 45.7222C89.2633 39.6309 84.209 35.3438 77.6154 35.3438C71.0218 35.3438 66.576 39.1037 65.616 44.756C64.6561 50.4083 68.9419 56.1842 75.5355 56.1842Z",
    fill: "#181658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5016 44.0834C87.3559 47.5622 87.1356 56.3864 84.7391 57.0081C83.7834 57.2561 81.7476 56.6487 79.6755 55.3917L80.976 64.6531H73.2964L75.94 52.2498C74.4656 50.5078 73.4678 48.373 73.6345 45.9809C74.115 39.0884 83.6474 40.6046 85.5016 44.0834Z",
    fill: "#D4A181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9639 44.1025C84.4953 44.3801 81.5374 45.7914 79.179 47.8158C78.9002 47.6671 78.5805 47.5827 78.2407 47.5827C77.1526 47.5827 76.2706 48.4479 76.2706 49.5152C76.2706 49.9508 76.4176 50.3527 76.6655 50.6759C76.1986 51.4504 75.8801 52.264 75.7757 53.1004C74.1578 53.1004 68.253 46.9386 74.1353 41.1412C80.0176 35.3439 88.5183 43.6199 85.9639 44.1025Z",
    fill: "#181658"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7368 91.3848L82.3378 132.361L90.802 162.563H96.9755L87.9811 91.3848H70.7368Z",
    fill: "#56919C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6332 91.3848C67.3649 112.505 66.4499 124.024 66.1681 125.943C65.8864 127.862 61.6264 140.068 53.3882 162.563H59.7835C70.2714 140.983 76.126 128.776 77.3473 125.943C78.5687 123.109 82.3378 111.59 88.0148 91.3848H67.6332Z",
    fill: "#89C5CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8169 168.361L53.1369 161.598H59.8565C63.0428 163.852 67.2026 165.677 72.3359 167.073V168.361H60.1765L56.0167 167.717V168.361H52.8169Z",
    fill: "#191847"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9355 168.361L90.2555 161.598H96.9752C100.161 163.852 104.321 165.677 109.455 167.073V168.361H97.2952L93.1354 167.717V168.361H89.9355Z",
    fill: "#191847"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6759 87.526L65.3627 87.5525C61.2339 100.968 59.005 108.086 58.6759 108.907C57.9355 110.754 59.5023 113.567 60.1724 115.079C57.9901 116.062 58.2226 112.421 55.4697 113.711C52.9569 114.887 51.0455 117.019 48.1424 115.216C47.7855 114.995 47.3943 114.16 48.3394 113.508C50.6937 111.883 54.0865 109.039 54.5449 108.103C55.17 106.826 56.547 99.9674 58.6759 87.526ZM97.8654 87.2656L108.072 94.8098C110.841 95.5617 113.153 96.4971 115.011 97.6162C115.45 98.0186 115.98 98.8335 114.16 98.6927C112.341 98.5518 110.421 98.486 110.169 99.1107C109.918 99.7354 111.019 100.482 110.512 101.325C110.174 101.887 108.575 100.478 105.717 97.0984L95.609 92.8797L97.8654 87.2656Z",
    fill: "#D4A181"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6775 59.2842L80.4445 58.8065C90.7106 67.733 94.9273 84.8818 107.511 93.9662L104.482 97.745C82.6517 95.0244 77.2408 74.107 77.6775 59.2842Z",
    fill: "#C5CFD6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6167 94.284C76.7111 94.284 84.8719 94.284 90.0991 94.284C91.2179 94.284 91.0071 92.658 90.8454 91.8375C88.9789 82.3684 81.6931 72.1611 81.6931 58.682L74.6312 57.5674C68.7901 67.023 66.7702 78.6648 65.6167 94.284Z",
    fill: "#C7D1D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0999 57.5671C74.3384 57.5671 74.5569 57.5821 74.7554 57.6121L76.9675 57.7393C83.3103 79.3765 85.0596 93.8125 82.2154 101.047L62.9456 101.048C61.804 103.727 60.7115 105.982 59.6683 107.811H54.4177C53.9235 91.7286 57.7223 78.0788 65.8139 66.8614C64.7883 66.5649 63.976 65.8727 63.3772 64.7852C60.7961 60.0973 61.7283 57.5163 64.4867 56.6679C67.2451 55.8195 69.705 57.5671 74.0999 57.5671Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.096 101.048L62.9448 101.048C64.2766 97.9222 65.6753 94.2181 67.1409 89.9355C67.747 95.0388 68.732 98.7431 70.096 101.048Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.456 133.083C170.456 132.458 170.963 131.951 171.588 131.951H187.431C188.057 131.951 188.563 132.458 188.563 133.083V169.297C188.563 169.922 188.057 170.429 187.432 170.429H171.588C170.963 170.429 170.456 169.922 170.456 169.297V133.083Z",
    fill: "#2D72FE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.214 99.1317C199.214 98.5067 199.721 98 200.346 98H216.19C216.815 98 217.321 98.5067 217.321 99.1317V169.297C217.321 169.922 216.815 170.429 216.19 170.429H200.346C199.721 170.429 199.214 169.922 199.214 169.297V99.1317Z",
    fill: "#2D72FE",
    fillOpacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M227.973 134.215C227.973 133.59 228.479 133.083 229.104 133.083H244.948C245.573 133.083 246.08 133.59 246.08 134.215V169.297C246.08 169.922 245.573 170.429 244.948 170.429H229.104C228.479 170.429 227.973 169.922 227.973 169.297V134.215Z",
    fill: "#E1292B",
    fillOpacity: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.731 134.215C256.731 133.59 257.238 133.083 257.863 133.083H273.706C274.331 133.083 274.838 133.59 274.838 134.215V169.297C274.838 169.922 274.331 170.429 273.706 170.429H257.863C257.238 170.429 256.731 169.922 256.731 169.297V134.215Z",
    fill: "#E1292B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2131_15722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.12,
    height: 114.866,
    fill: "white",
    transform: "translate(75.8311 32.1562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgBodyBattery);
export default __webpack_public_path__ + "static/media/org-body-battery.47527bc577e39a03759f4e635db936d8.svg";
export { ForwardRef as ReactComponent };